export default "__VITE_ASSET__CVziSZgG__"